module.exports = __webpack_public_path__ + "static/media/ethical-hacking.0cd057c0.png";